export default function PageTitle({ title }: { title: string }) {
  return (
    <div>
      <h3 className="g2-text-burgundy fw-bold g2-header-underline">{title.toUpperCase()}</h3>
    </div>
  );
}
